import { render, staticRenderFns } from "./audit-task-view.vue?vue&type=template&id=018cd048"
import script from "./audit-task-view.vue?vue&type=script&lang=js"
export * from "./audit-task-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports